"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_scss_1 = __importDefault(require("./index.scss"));
exports.default = {
    slider_small_thickness: index_scss_1.default.slider_small_thickness,
    slider_medium_thickness: index_scss_1.default.slider_medium_thickness,
    slider_large_thickness: index_scss_1.default.slider_large_thickness,
    slider_thumb_size: index_scss_1.default.slider_thumb_size,
    slider_mark_label_top: index_scss_1.default.slider_mark_label_top,
    slider_mark_label_left: index_scss_1.default.slider_mark_label_left,
    slider_mark_label_font: index_scss_1.default.slider_mark_label_font,
    slider_value_label_font: index_scss_1.default.slider_value_label_font,
    slider_value_label_min_width: index_scss_1.default.slider_value_label_min_width,
    slider_value_label_min_height: index_scss_1.default.slider_value_label_min_height,
    slider_value_label_padding: index_scss_1.default.slider_value_label_padding,
    slider_value_label_border_radius: index_scss_1.default.slider_value_label_border_radius,
    slider_value_label_top: index_scss_1.default.slider_value_label_top,
    slider_value_label_before_size: index_scss_1.default.slider_value_label_before_size,
    slider_value_label_before_bottom: index_scss_1.default.slider_value_label_before_bottom,
    slider_value_label_circle_font_size: index_scss_1.default.slider_value_label_circle_font_size,
    slider_value_label_circle_line_height: index_scss_1.default.slider_value_label_circle_line_height,
    slider_value_label_circle_z_index: index_scss_1.default.slider_value_label_circle_z_index,
    slider_value_label_vertical_top: index_scss_1.default.slider_value_label_vertical_top,
    slider_value_label_vertical_right: index_scss_1.default.slider_value_label_vertical_right,
    slider_value_label_vertical_before_right: index_scss_1.default.slider_value_label_vertical_before_right,
    slider_value_label_vertical_before_top: index_scss_1.default.slider_value_label_vertical_before_top,
};
